import TrackedContentElement from "@/components/course/tree/TrackedContentElement";
import type { CourseTreeNode } from "@/types/generated";
import type { Storyboard } from "@/types/storyboard";
import type { ReactNode } from "react";

const mapStoryboardElementsToTrackedContentElements = (
  storyboards: Storyboard[],
  selectedContentElements: CourseTreeNode[]
): ReactNode[] => {
  return storyboards.map((storyboard) => {
    const contentElement = selectedContentElements.find(
      (element) => element.id === storyboard.contentElementId
    );

    if (!contentElement) return null;

    return (
      <TrackedContentElement
        key={storyboard.contentElementId}
        el={contentElement}
        storyboard={storyboard}
      />
    );
  });
};

export { mapStoryboardElementsToTrackedContentElements };
